import { API_V4_BASE_URL } from 'settings';
import { get } from './api';

export interface ISearchLessonsParams {
  hash: string;
  page: number;
  search: string;
}

export const searchLessons = async ({ hash, page, search }: ISearchLessonsParams) => {
  const response = await get({
    url: `/learner/course/${hash}/lessons`,
    baseURL: API_V4_BASE_URL,
    params: {
      page,
      search: search || null
    },
  });
  return response.data;
};